import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PrismicReact from 'prismic-reactjs'
import PropTypes from 'prop-types'

const propTypes = {
  slice: PropTypes.object,
  linkResolver: PropTypes.func
}

class ProductSection extends Component {
  render() {
    let { 
      slice,
      linkResolver
    } = this.props
    const sp = slice.primary
    // console.log(slice)

    return (
      <section className="section-product">

        <div className="section-product-bg" style={{backgroundImage: `url(${sp.product_banner_image.url})`}}>
        </div>

        <div className="section-product-content">
          <div className="container">
              <div className="flexbox content-card">
                <div className="flex-item half">
                {/* {PrismicReact.RichText.render(sp.product_subtitle)} */}
                {PrismicReact.RichText.render(sp.product_title)}
                {PrismicReact.RichText.render(sp.section_description)}
                <div className="button-group">
                  {/* <Link to={PrismicReact.Link.url(sp.product_link, linkResolver)} className="button button-large">{sp.product_link_name}</Link> */}
                  <Link to={PrismicReact.Link.url(sp.our_strains_link, linkResolver)} className="button button-large">{sp.our_strains_link_name}</Link>
                </div>
                </div>
              </div>
            </div>
        </div>
          
      </section>
    )
  }
}

ProductSection.propTypes = propTypes

export default ProductSection


// WEBPACK FOOTER //
// ./src/components/Home/ProductSection.js